import { useEffect, useState } from "react";
import gdBrandsApi, { GdBrand } from "../../../api-services/gd-brands-api.service";

const ICONS = "/iceholidays-assets/images/icons";

const CATEGORY_LOGOS: Record<string, string> = {
  "GD Standard": `${ICONS}/gd.png`,
  "FS": `${ICONS}/fs.png`,
  "GD Premium": `${ICONS}/premium.png`,
  "GD Domestic": `${ICONS}/gd_domestic.png`,
  "GD Signature": `${ICONS}/gd_signature.png`,
  "GD FLY CRUISE": `${ICONS}/fly_cruise.png`,
};

export const brandLogoForCategory = (category?: string): string | undefined => {
  if (!category) return undefined;
  if (CATEGORY_LOGOS[category]) return CATEGORY_LOGOS[category];
  if (category.includes("CRUISE")) return `${ICONS}/cruise.png`;
  if (category.includes("GD In Depth")) return `${ICONS}/gd.png`;
  return undefined;
};

export const BRAND_FILTER_LOGOS: Record<string, string> = {
  GD_Standard: `${ICONS}/gd.png`,
  GD_Signature: `${ICONS}/gd_signature.png`,
  GD_In_Depth: `${ICONS}/gd.png`,
  FS: `${ICONS}/fs.png`,
  CRUISE: `${ICONS}/cruise.png`,
  GD_FLY_CRUISE: `${ICONS}/fly_cruise.png`,
};

const BRAND_CODE_PATTERNS: Record<string, RegExp> = {
  GD_Signature: /signature/i,
  GD_In_Depth: /in[- ]?depth/i,
  FS: /\bfs\b/i,
  GD_FLY_CRUISE: /fly cruise/i,
  CRUISE: /world cruise|gd cruise/i,
  GD_Standard: /classic|standard/i,
};

export function findGdBrandByCode(brands: GdBrand[], code: string): GdBrand | undefined {
  const pattern = BRAND_CODE_PATTERNS[code];
  return pattern ? brands.find((brand) => pattern.test(brand.title)) : undefined;
}

export function findGdBrandByCategory(brands: GdBrand[], category?: string): GdBrand | undefined {
  if (!category) return undefined;
  const code = Object.keys(BRAND_CODE_PATTERNS).find((key) => BRAND_CODE_PATTERNS[key].test(category));
  return code ? findGdBrandByCode(brands, code) : undefined;
}

export function brandTooltipText(brands: GdBrand[], category?: string): string | undefined {
  const brand = findGdBrandByCategory(brands, category);
  return brand?.description ? `${brand.title} — ${brand.description}` : undefined;
}

export function useGdBrands(): { brands: GdBrand[]; loading: boolean } {
  const [brands, setBrands] = useState<GdBrand[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    gdBrandsApi.getBrands()
      .then((data) => {
        if (active) setBrands(data);
      })
      .catch(() => {
        if (active) setBrands([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { brands, loading };
}
